import { lazy } from "react";
import ProtectedRoute from "../guards/ProtectedRoute";
import { LAYOUT_IDENTIFIERS, MODULE_PATHS } from "../../utils/moduleConfig";

const MainLayout = lazy(() => import("../../layouts/MainLayout/MainLayout"));
const WorkspaceHomePage = lazy(() =>
  import("../../pages/WorkspaceHome/WorkspaceHomePage")
);

const workspaceHomeRoutes = {
  path: MODULE_PATHS.workspaceHome,
  element: (
    <ProtectedRoute>
      <MainLayout identifier={LAYOUT_IDENTIFIERS.workspaceHome} />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <WorkspaceHomePage />,
    },
  ],
};

export default workspaceHomeRoutes;
